module.exports = __webpack_public_path__ + "static/media/5f85e6b96e158.db9d1df4.jpg";